import { create } from "zustand";

export interface IBaseAnalyticsCombined {
  id: number; // indexed id, unique for each row not related to the trade but will be used to provide ag chart with a unique field.
  tradeID: string;
  spread: number;
  spreadBPS: number | null;
  blockBPS: number | null;
  spreadAsk?: number; // Not sure what this is doing.
  spreadBid?: number; // Not sure what this is doing.
  blockAsk?: number; // Not sure what this is doing.
  blockBid?: number; // Not sure what this is doing.
  maturityDate: string; // Not sure what this is doing.
  sector?: string; // Not sure what this is doing.
  ticker: string; // Not sure what this is doing.
  traderLocation?: string; // Not sure what this is doing.
  block?: number;
  lastAction: string;
  dateTimeSent: string;
  dateTimeAffirmed?: string; // Might not be getting used for anything.
  dateTimeExecuted: string; // Is this needed - is the above enough?
  currency: string;
  issueCountry: string;
  notional: number;
  instrumentType: string;
  structureType: string;
  securityType: string;
  strategyType: string;
  securityName: string;
  currencyLeg1?: string;
  DV01: number;
  OPCustomer: string;
  RPCustomer: string;
  DV01Buckets: string;
  dateTimeQuoted?: string;
  priceType?: string;
  rate?: number | string;
  issuer?: string;
  // MaturityDate?: string | Date; - // Seems to be for axes.
  // Sector: string; - // Sector is coming from the client summary report - It does not seem to be getting used anywhere.
  // Ticker: string; - // Client summary - It does not seem to be getting used anywhere. (seems to be a near duplciate from the issuer / issuer could be used instead for most use cases.)
  OPTraderName: string; // Not sure what this is? The OP who made it or do we need 2 names here?
  RPTraderName: string;
  direction?: string;
  mid?: number;
  cover: number | string; // Should be number but getting lots of empty strings.
  spreadToMid: number;
  bidOffer?: number;
  marketMid?: number | string; // Not sure what this is.
  tradeCostVsMid: number | string; // need to understand what to do on empty strings.
  timeToQuote: number | string; // Should be number but getting lots of empty strings.
  spreadPriceType?: string;
}

type State = {
  analyticData: IBaseAnalyticsCombined[];
};

type Action = {
  // eslint-disable-next-line no-unused-vars
  updateAnalyticData: (incomingData: State["analyticData"]) => void;
};

const analyticDataStore = create<State & Action>((set) => ({
  analyticData: [],
  updateAnalyticData: (incomingData) => {
    set(() => ({
      analyticData: incomingData,
    }));
  },
}));

export default analyticDataStore;

//  {
//       id: 1, // indexed id, unique for each row not related to the trade but will be used to provide ag chart with a unique field.
//       tradeID: "LDC-1-1",
//       spread: 200, //NOT on EXCEL data
//       lastAction: "Affirmed", // EXCEL data does NOT have any usefull last actions.
//       dateTimeSent: "2025-06-30T04:53:18.820", // EXCEL data has this as time rather than a date.
//       dateTimeQuoted: "2025-06-30T04:54:18.820",
//       dateTimeExecuted: "2025-06-30T04:55:18.820", // Is this needed - is the above enough?
//       dateTimeAffirmed: "2025-06-30T04:56:18.820",
//       currency: "AUD",
//       issueCountry: "Australia",
//       notional: 100000,
//       instrumentType: "SWP",
//       structureType: "IBS",
//       securityType: "SWP", // HOW is this different to the "SWP" on instrumentType??
//       strategyType: "Outright",
//       securityName: "IBS AUD 13-Aug-2019 to 13-Aug-2024",
//       currencyLeg1: "AUD",
//       DV01: 50000,
//       OPCustomer: "LDC",
//       RPCustomer: "JBD",
//       DV01Bucket: "0 - 5k",
//       // MaturityDate?: string | Date, - // Seems to be for axes.
//       // Sector: string, - // Sector is coming from the client summary report - It does not seem to be getting used anywhere.
//       // Ticker: string, - // Client summary - It does not seem to be getting used anywhere. (seems to be a near duplciate from the issuer / issuer could be used instead for most use cases.)
//       OPTraderName: "Aiden N",
//       RPTraderName: "John Doe",
//       direction: "Buy",
//       mid: 5,
//       cover: 10,
//       spreadToMid: 0.54,
//       bidOffer: 6,
//       tradeCostVsMid: 99,
//       priceType: "bps",
//       rate: "",
//       issuer: "CIT",
//     },
//     {
//       id: 2, // indexed id, unique for each row not related to the trade but will be used to provide ag chart with a unique field.
//       tradeID: "LDC-1-2",
//       spread: 300, //NOT on EXCEL data
//       lastAction: "Qutoed", // EXCEL data does NOT have any usefull last actions.
//       dateTimeSent: "2025-04-30T04:53:18.820", // EXCEL data has this as time rather than a date.
//       dateTimeQuoted: "2025-04-30T04:54:18.820",
//       dateTimeExecuted: "2025-04-30T04:54:20.820", // CURRENTLY USED IN FLOW FILTER (Date) Is this needed - is the above enough?
//       dateTimeAffirmed: "2025-04-30T04:56:20.820",
//       currency: "UST",
//       issueCountry: "Canada",
//       notional: 200000,
//       instrumentType: "BND",
//       structureType: "OPT Pack",
//       securityType: "SWO", // HOW is this different to the "SWP" on instrumentType??
//       strategyType: "Structure",
//       securityName: "GOVT ACGB 21Apr26 4.25%",
//       currencyLeg1: "UST",
//       DV01: 100000,
//       OPCustomer: "LDC",
//       RPCustomer: "CBA",
//       DV01Bucket: "10k - 20k",
//       // MaturityDate?: string | Date, - // Seems to be for axes.
//       // Sector: string, - // Sector is coming from the client summary report - It does not seem to be getting used anywhere.
//       // Ticker: string, - // Client summary - It does not seem to be getting used anywhere. (seems to be a near duplciate from the issuer / issuer could be used instead for most use cases.)
//       OPTraderName: "Jonty P",
//       RPTraderName: "Don J",
//       direction: "Buy",
//       mid: 7,
//       cover: 11,
//       spreadToMid: 0.88,
//       bidOffer: 4,
//       tradeCostVsMid: 89,
//       priceType: "%",
//       rate: "",
//       issuer: "BAM",
//     },
